import React, { useState } from "react";
import CommentsSortButton from "../CommentsSortButton";
import CommentsHistoryList from "./CommentsHistoryList";
import "./CommentHistoryView.css";

export default function CommentsHistoryView({
   users,
   comments,
   setComments,
   commentsView,
   CommentButton,
   HistoryButton,
   projectId,
}) {
   // Stateful data

   // Sort Options - options (desc, asc)
   // True - most recent to oldest | False - oldest to most recent
   const [sortBy, setSortBy] = useState("desc");
   //Functions

   function toggleSort(sortType) {
      if (sortType === "desc") {
         const sortedDescending = comments.sort((a, b) => {
            return new Date(b.time) - new Date(a.time);
         });
         setComments(sortedDescending);
      } else if (sortType === "asc") {
         const sortedAscending = comments.sort((a, b) => {
            return new Date(a.time) - new Date(b.time);
         });
         setComments(sortedAscending);
      }
   }

   if (commentsView === true) {
      return null;
   }
   return (
      <section className="comments-view">
         <div className="comments-view-top">
            <div>
               {CommentButton}
               {HistoryButton}
            </div>
            <CommentsSortButton
               sortBy={sortBy}
               toggleSort={toggleSort}
               setSortBy={setSortBy}
            />
         </div>

         <CommentsHistoryList
            users={users}
            comments={comments}
            sort={sortBy}
            projectId={projectId}
         />
      </section>
   );
}
